import React, { useMemo, useState } from "react";
import moment from "moment";
import styles from "./index.module.scss";
import Timer from "../../../stories/common/timer";
// import ReleaseBtn from "../../../stories/common/flipper-vault-card/releaseButton";
// import { formatPhoneNumber } from "../../../utils/utils";
import Buttonc from "../../../stories/common/button";
import { useNavigate } from "react-router-dom";
import { InvestorBidInitiated } from "../../../utils/inv-exch-amplitude";
import ContactWeb from "../../flipper-vault/web-list-view/list-row/contact-web";
import SendPropertyInfo from "./send-property-info";

interface InvCardProps {
  id?: string;
  expiryAt: string;
  accountId: string;
  checkoutId: string;
  releasedAt: string;
  accountName: string;
  email: string;
  engmtStatus?: string;
  plainPhone: string;
  propertyId?: string;
  propertySfid?: string;
  accountSfid?: string;
  address: string;
  userName?: string;
  myAccounts?: boolean;
  createdAt: string;
  bidCount?: number;
  portalStatus: string;
  contacts?: Array<{
    id: string;
    name: string;
    sfid: string;
    email: string;
    mobile: string;
  }>;
}

export default function InvWebCard({
  address,
  checkoutId,
  accountName,
  expiryAt,
  createdAt,
  releasedAt,
  email,
  plainPhone,
  accountId,
  userName,
  myAccounts = false,
  propertyId,
  bidCount,
  contacts,
  accountSfid,
  propertySfid,
  engmtStatus,
  portalStatus
}: InvCardProps) {
  const [isExpired, setIsExpired] = useState(
    moment.utc(expiryAt).isBefore(moment().utc())
  );
  const navigate = useNavigate();
  const [showReleaseBtn, setShowReleaseBtn] = useState(
    createdAt &&
      -moment.utc(createdAt).diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
      ? true
      : false
  );
  const [showSendPropertyInfo, setShowSendPropertyInfo] = useState(false);

  const vaultStatus = useMemo(() => {
    if (releasedAt !== null) {
      return "RELEASED";
    } else if (isExpired && releasedAt === null) {
      return "EXPIRED";
    } else {
      return "ACTIVE";
    }
  }, [releasedAt, isExpired]);

  return (
    <div className={styles.invCardWrapper}>
      <div className={styles.invCardDetails}>
        <div className={styles.AccName}>{accountName}</div>
        <div className={styles.AccAddress}>{address}</div>
        {myAccounts && (
          <div className={styles.FlipperVaultCardOwner}>
            <div className={styles.FlipperVaultCardOwnerTitle}>
              Checked Out By
            </div>
            <div className={styles.FlipperVaultCardOwnerValue}>{userName}</div>
          </div>
        )}
        {portalStatus === "Pending Price Cut" && (
          <div className={styles.portalStatus}><span className={styles.dot}></span>{portalStatus}</div>
        )}
      </div>
      <div className={styles.contactInfo}>
        {!isExpired && releasedAt === null && !myAccounts && (
          <ContactWeb
            account={{
              contacts: contacts,
              acctSfid: accountSfid,
              acctId: accountId,
              propertyId: propertyId,
              propertySfid: propertySfid
            }}
          />
        )}
      </div>
      <div className={styles.tagsWrap}>
        <div
          className={`${styles.TAG} ${
            styles[vaultStatus?.replaceAll(" ", "")]
          }`}
        >
          {!myAccounts && (
            <>
              Checkout Status <br />
            </>
          )}
          <span className={myAccounts ? `${styles.myAccountStatus}` : ""}>
            {vaultStatus?.toLowerCase()}
          </span>
        </div>

        {/* {!myAccounts && (
          <div
            className={`${styles.TAG} ${
              styles[engmtStatus?.toLowerCase() || ""]
            }`}
          >
            Engagement Status <br />
            <span>{engmtStatus}</span>
          </div>
        )} */}
      </div>
      {/* {!isExpired && releasedAt === null && ( */}
      {/* <> */}
      <div className={styles.TimerWrapper}>
        {!isExpired && releasedAt === null && (
          <Timer
            className={styles.Timer}
            acctId={accountId}
            time={expiryAt}
            setShowReleaseBtn={setShowReleaseBtn}
            onExpire={() => {
              setIsExpired(true);
            }}
            createdAt={createdAt}
            classNameTitle={styles.TimerTitle}
            classNameClock={styles.classNameClock}
          />
        )}
      </div>
      <div className={styles.btnWrap}>
        {!isExpired && releasedAt === null && (
          <>
            {!myAccounts && (
              <Buttonc
                type="button"
                label="Add Bid"
                size="large"
                onClick={() => {
                  InvestorBidInitiated({
                    property_id: propertyId ?? "",
                    investor_id: accountId,
                    investor_sfid: accountSfid,
                    property_sfid: accountSfid ?? ""
                  });
                  navigate(
                    `/internal/${propertyId}?acctId=${accountId}&bid=true`
                  );
                }}
              />
            )}
          </>
        )}
      </div>
      <div className={styles.btnWrap}>
        {!isExpired && releasedAt === null && (
          <>
            {!myAccounts && (
              <Buttonc
                className={styles.viewPropertyBtn}
                type="button"
                label="Send Property Info"
                // icon={<img src="/images/home-prop.svg" alt="" />}
                size="large"
                onClick={() => {
                  // navigate(
                  //   `/internal/${propertyId}?acctId=${accountId}&bid=true`
                  // );
                  setShowSendPropertyInfo(true);
                }}
              />
            )}
          </>
        )}
        <SendPropertyInfo Visible={showSendPropertyInfo} setVisible={setShowSendPropertyInfo} pubPropertyId={propertyId} />
      </div>
    </div>
  );
}
